module.exports = __webpack_public_path__ + "img/07.a7d96c0a.webp";